import {FC, useEffect, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import {PageTitle} from '../../../../_metronic/layout/core'
import {Loading} from '../../../components/Loading/Loading'
import {GET, POST} from '../../../services/api'
import {i18n} from '../../../translate/i18n'
import Swal from 'sweetalert2'

import styles from './createConfig.module.css'

import {Input} from '../../../components/Input/Input'
import {Button} from '../../../components/Button/Button'
import {BreadCrumbs} from '../../../components/BreadCrumbs/breadCrumbrs'

type PluginconfigType = {
  id: number
  name: string
  content: any
  plugintemplateId: number
  plugintypeId: number
}

type PaymentType = {
  id: number
  name: string
  image: string | null
  parameters: string
  plugintypeId: number
  pluginconfig: PluginconfigType
  ableCredit: boolean | null
  ableDebit: boolean | null
  ableAlimentation: boolean | null
  ablePix: boolean | null
}

type ConfigInputsType = {
  name: string
  label: string
  value: string
}

type ModalityType = {
  id: number
  code: string
  name: string
  status: string
  type: string
  checked: boolean
}

const PaymentCreateConfigContent: FC = () => {
  const {id} = useParams()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [payment, setPayment] = useState<PaymentType | null>()
  const [configInputs, setConfigInputs] = useState<(ConfigInputsType | undefined)[]>([])
  const [modalities, setModalities] = useState<ModalityType[]>([])

  /*Variaveis utilizadas para todos os plugins exeto o de pagamento na entrega */
  const [showDiscountValues, setShowDiscountValues] = useState(false)
  const [discountPixAble, setDiscountPixAble] = useState<boolean>(false)
  const [discountPixType, setDiscountPixType] = useState<'percentage' | 'monetary' | null>()
  const [discountPixValue, setDiscountPixValue] = useState<number>()

  const [discountCardAble, setDiscountCardAble] = useState<boolean>(false)
  const [discountCardType, setDiscountCardType] = useState<'percentage' | 'monetary' | null>()
  const [discountCardValue, setDiscountCardValue] = useState<number>()
  const [hasPix, setHasPix] = useState(false)

  // Estado para controlar valores dos campos de configuração
  const [configValues, setConfigValues] = useState<{[key: string]: string}>({})

  // Função para atualizar valores dos campos de configuração
  const updateConfigValue = (fieldName: string, value: string) => {
    console.log(`[DEBUG] updateConfigValue called: fieldName=${fieldName}, value=${value}`)
    setConfigValues((prev) => ({
      ...prev,
      [fieldName]: value,
    }))
  }

  const getPlugintemplate = async () => {
    try {
      setShowDiscountValues(id !== '44' ? true : false)
      const res = await GET(`/plugintemplate/payments/${id}`)
      if (res.success && res.data && res.data.length > 0) {
        setPayment(res.data[0])
        const newInputs: (ConfigInputsType | undefined)[] = Object.entries(
          JSON.parse(res.data[0].parameters).config
        ).map((configInput) => {
          if (
            configInput[0] !== undefined &&
            configInput[1] !== undefined &&
            typeof configInput[1] === 'string'
          ) {
            const input: ConfigInputsType = {
              name: configInput[0],
              label: configInput[1],
              value: '', // Valor inicial vazio para criação
            }
            return input
          }
          return undefined
        })
        setConfigInputs(newInputs.filter((input) => input))

        const modalitiesRes = await GET('/location')
        if (modalitiesRes.data && modalitiesRes.data.length > 0) {
          const filterModalities = modalitiesRes.data.filter(
            (modality: ModalityType) => modality.type !== 'address'
          )
          const newModalities = filterModalities.map((modality: ModalityType) => {
            return {
              id: modality.id,
              code: modality.code,
              name: modality.name,
              status: modality.status,
              type: modality.type,
              checked: false,
            }
          })
          setModalities(newModalities)
        }

        if (res.data[0].parameters.includes('pix')) {
          setHasPix(true)
        }

        return
      }
      Swal.fire({
        icon: 'error',
        title: 'Erro!',
        text: 'Falha ao recuperar meio de pagamento.',
      }).then(() => navigate(-1))
      return
    } catch (e) {
      console.log(e)
      Swal.fire({
        icon: 'error',
        title: 'Erro!',
        text: 'Falha ao recuperar meio de pagamento.',
      }).then(() => navigate(-1))
    }
  }

  const init = async () => {
    setLoading(true)
    await getPlugintemplate()
    setLoading(false)
  }

  useEffect(() => {
    init()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const createPaymentConfig = async () => {
    console.log('[DEBUG] createPaymentConfig called')
    console.log('[DEBUG] configValues:', configValues)
    console.log('[DEBUG] configInputs:', configInputs)

    if (payment) {
      let integrationContent: any = {}
      configInputs.forEach((config) => {
        if (config) {
          console.log(`[DEBUG] Processing config field: ${config.name}`)
          if (!config.name.includes('able') && config.name !== 'pix') {
            // Usa o valor do estado React em vez de DOM query
            integrationContent[config.name] = configValues[config.name] || ''
            console.log(`[DEBUG] Set ${config.name} = ${integrationContent[config.name]}`)
          } else {
            integrationContent[config.name] = '0'
            console.log(`[DEBUG] Set ${config.name} = 0 (default)`)
          }
        }
      })

      console.log('[DEBUG] integrationContent after processing:', integrationContent)

      // repassar os campos de desconto do plugin de pagamento na entrega
      if (id !== '44') {
        if (discountPixAble && hasPix) {
          if (!discountPixType || discountPixValue === undefined || discountPixValue <= 0) {
            Swal.fire({
              icon: 'error',
              title: 'Erro!',
              text: 'Por favor, preencha corretamente os campos de desconto do Pix.',
            })
            return
          }
        }

        integrationContent['discountPixAble'] = discountPixAble
        integrationContent['discountPixType'] = discountPixType
        integrationContent['discountPixValue'] = discountPixValue
        if (discountCardAble) {
          if (!discountCardType || discountCardValue === undefined || discountCardValue <= 0) {
            Swal.fire({
              icon: 'error',
              title: 'Erro!',
              text: 'Por favor, preencha corretamente os campos de desconto do Cartão.',
            })
            return
          }
        }

        integrationContent['discountCardAble'] = discountCardAble
        integrationContent['discountCardType'] = discountCardType
        integrationContent['discountCardValue'] = discountCardValue
      }

      try {
        setLoading(true)
        const integrationRes = await POST('/pluginconfig', {
          plugintypeId: payment.plugintypeId,
          plugintemplateId: parseInt(id ? id : '0'),
          name: payment.name,
          content: integrationContent,
          locationsId: modalities
            .filter((modality) => modality.checked)
            .map((modality) => modality.id),
        })
        setLoading(false)
        if (
          integrationRes.success === true &&
          integrationRes.dados &&
          integrationRes.dados.clientIdPagseguro
        ) {
          localStorage.setItem('clientIdPagseguro', integrationRes.dados.clientIdPagseguro)
          localStorage.setItem('emailPagseguro', integrationRes.dados.content.email)
          localStorage.setItem('pluginspaceId', integrationRes.dados.pluginspaceId)
          Swal.fire({
            icon: 'success',
            title: 'Integração cadastrada',
            text: 'Cadastro realizado com sucesso!',
          }).then(() =>
            integrationRes.dados.content.environment &&
            integrationRes.dados.content.environment === '1'
              ? (window.location.href = `https://connect.pagseguro.uol.com.br/oauth2/authorize?response_type=code&client_id=${integrationRes.dados.clientIdPagseguro}&redirect_uri=${integrationRes.dados.content.redirect_uri}&scope=payments.read+payments.create+payments.refund&state=xyz`)
              : (window.location.href = `https://connect.sandbox.pagseguro.uol.com.br/oauth2/authorize?response_type=code&client_id=${integrationRes.dados.clientIdPagseguro}&redirect_uri=${integrationRes.dados.content.redirect_uri}&scope=payments.read+payments.create+payments.refund&state=xyz`)
          )
        } else if (integrationRes.success === true) {
          Swal.fire({
            icon: 'success',
            title: 'Integração cadastrada',
            text: 'Cadastro realizado com sucesso!',
          }).then(() => navigate(`/configuracoes/pagamentos/${id}`))
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Erro',
            text: 'Erro ao cadastrar integração!',
          })
        }
      } catch (e) {
        setLoading(false)
        console.log(e)
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao cadastrar integração!',
        })
      }
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Falha ao encontrar meio de pagamento!',
      })
    }
  }

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>{i18n.t(`payment.add`)}</span>
                <BreadCrumbs />
              </h3>
            </div>
            {payment && (
              <div className='card-body d-flex flex-column gap-5'>
                <div className={styles.goBack}>
                  {payment.image && <img src={payment.image} alt={payment.name} />}
                </div>
                <div className={styles.form}>
                  <h2>{i18n.t(`payment.basic_settings`)}</h2>
                  {configInputs
                    .filter(
                      (input) => input && !input.name.includes('able') && input.name !== 'pix'
                    )
                    .map((config) => (
                      <div key={config?.name}>
                        <Input
                          inputAttr={{
                            type: 'text',
                          }}
                          placeholder={config?.label}
                          label={config?.label}
                          name={config?.name}
                          value={config?.name ? configValues[config.name] || '' : ''}
                          change={(value: string) => {
                            if (config?.name) {
                              updateConfigValue(config.name, value)
                            }
                          }}
                        />
                      </div>
                    ))}
                </div>
                <div className={styles.formModalities}>
                  <h2>{i18n.t(`payment.modalities`)}</h2>
                  {modalities.map((modality) => (
                    <Input
                      inputAttr={{
                        type: 'checkbox',
                      }}
                      key={modality.id}
                      label={modality.name}
                      checked={modality.checked}
                      value={modality.checked}
                      change={(value: boolean) => {
                        setModalities(
                          modalities.map((modalityToChange) => {
                            if (modalityToChange.id === modality.id) modality.checked = value
                            return modalityToChange
                          })
                        )
                      }}
                    />
                  ))}
                </div>

                {showDiscountValues && (
                  <div className={styles.formDescount}>
                    <h2> {i18n.t(`payment.config_descount_payment`)}</h2>

                    {hasPix && (
                      <Input
                        inputAttr={{
                          type: 'checkbox',
                        }}
                        label={i18n.t(`payment.able_discount_pix`)}
                        value={discountPixAble}
                        checked={discountPixAble}
                        change={(value: boolean) => {
                          setDiscountPixAble(value)
                        }}
                      />
                    )}
                    {discountPixAble && hasPix && (
                      <div className='row '>
                        <div className='col-12 d-flex gap-5 align-items-center  '>
                          <div className='col-4'>
                            <Input
                              inputAttr={{type: 'newRadioModal'}}
                              label={i18n.t(`payment.discount_percentage`)}
                              value={'percentage'}
                              checked={discountPixType === 'percentage'}
                              change={() => {
                                setDiscountPixType('percentage')
                                setDiscountPixValue(0)
                              }}
                              name='typePixDiscount'
                              paddingLeft={'0px !important'}
                            />
                            <Input
                              inputAttr={{type: 'newRadioModal'}}
                              label={i18n.t(`payment.discount_monetary`)}
                              value={'monetary'}
                              checked={discountPixType === 'monetary'}
                              change={() => {
                                setDiscountPixType('monetary')
                                setDiscountPixValue(0)
                              }}
                              name='typePixDiscount'
                              paddingLeft={'0px !important'}
                            />
                          </div>

                          <Input
                            inputAttr={{
                              type: discountPixType === 'percentage' ? 'number' : 'money',
                            }}
                            currency='BRL'
                            locale='pt-BR'
                            value={
                              // eslint-disable-next-line eqeqeq
                              discountPixValue && parseFloat(discountPixValue.toString()) != 0
                                ? discountPixValue
                                : ``
                            }
                            placeholder={`0`}
                            change={(value: string) => setDiscountPixValue(parseFloat(value))}
                            label={i18n.t(`payment.discount_value`)}
                            minNumber={0}
                            maxNumber={100}
                            grow
                          />
                        </div>
                      </div>
                    )}

                    <Input
                      inputAttr={{
                        type: 'checkbox',
                      }}
                      label={i18n.t(`payment.able_discount_card`)}
                      value={discountCardAble}
                      checked={discountCardAble}
                      change={(value: boolean) => {
                        setDiscountCardAble(value)
                      }}
                    />
                    {discountCardAble && (
                      <div className='row '>
                        <div className='col-12 d-flex gap-5 align-items-center  '>
                          <div className='col-4'>
                            <Input
                              inputAttr={{type: 'newRadioModal'}}
                              label={i18n.t(`payment.discount_percentage`)}
                              value={'percentage'}
                              checked={discountCardType === 'percentage'}
                              change={() => {
                                setDiscountCardType('percentage')
                                setDiscountCardValue(0)
                              }}
                              name='typeCardDiscount'
                              paddingLeft={'0px !important'}
                            />
                            <Input
                              inputAttr={{type: 'newRadioModal'}}
                              label={i18n.t(`payment.discount_monetary`)}
                              value={'monetary'}
                              checked={discountCardType === 'monetary'}
                              change={() => {
                                setDiscountCardType('monetary')
                                setDiscountCardValue(0)
                              }}
                              name='typeCardDiscount'
                              paddingLeft={'0px !important'}
                            />
                          </div>

                          <Input
                            inputAttr={{
                              type: discountCardType === 'percentage' ? 'number' : 'money',
                            }}
                            currency='BRL'
                            locale='pt-BR'
                            value={
                              // eslint-disable-next-line eqeqeq
                              discountCardValue && parseFloat(discountCardValue.toString()) != 0
                                ? discountCardValue
                                : ``
                            }
                            placeholder={`0`}
                            change={(value: string) => setDiscountCardValue(parseFloat(value))}
                            label={i18n.t(`payment.discount_value`)}
                            minNumber={0}
                            maxNumber={100}
                            grow
                          />
                        </div>
                      </div>
                    )}
                  </div>
                )}
                <div className='d-flex justify-content-between align-items-center mt-4'>
                  <Button
                    text={i18n.t(`buttons.back`)}
                    color='info'
                    size='small'
                    horizontalPadding={6}
                    btnAttr={{
                      type: 'button',
                    }}
                    click={() => {
                      navigate('/configuracoes/pagamentos')
                    }}
                    btnClass='fw-bolder'
                  />
                  <Button
                    text={i18n.t(`buttons.save`)}
                    color='primary'
                    size='small'
                    horizontalPadding={6}
                    btnAttr={{
                      type: 'button',
                    }}
                    click={async () => await createPaymentConfig()}
                    btnClass='fw-bolder'
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  )
}

const PaymentCreateConfig: FC = () => {
  const {id} = useParams()

  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {title: i18n.t(`payment.methods`), path: 'configuracoes/pagamentos', isActive: true},
          {title: i18n.t(`payment.add`), path: `configuracoes/pagamentos/${id}`, isActive: true},
        ]}
      >
        {i18n.t(`payment.add`)}
      </PageTitle>
      <PaymentCreateConfigContent />
    </>
  )
}

export {PaymentCreateConfig}
